module.exports = __webpack_public_path__ + "img/bo.bo41d4956.svg";